module.exports = __webpack_public_path__ + "img/logo.d87e5f67.png";